import React from 'react';
import { Link } from 'react-router-dom';
import { dateReviver } from '../../helpers';
import { apiGet } from '../apiHelpers';
let config = require('../../cc-config.json');
export default class DataExtracts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            extracts: undefined,
            latestExtract: undefined,
            previousExtracts: undefined
        };
    }
    async componentDidMount() {
        let data = await apiGet('/api/extracts', { jsonReviver: dateReviver });
        const extracts = data.extracts;
        this.setState({ extracts: extracts, latestExtract: extracts[0], previousExtracts: extracts.slice(1) });
    }
    render() {
        return (React.createElement("article", null,
            React.createElement("section", { className: "main-col" },
                React.createElement("h1", { className: "h2" }, "Open data extracts"),
                React.createElement("p", null,
                    "Choose one of the links below to download an archive containing the open data collected on the Colouring ",
                    config.cityName,
                    " platform."),
                React.createElement("p", null,
                    "Colouring ",
                    config.cityName,
                    " contributions are open data, licensed under the",
                    ' ',
                    React.createElement("a", { href: "http://opendatacommons.org/licenses/odbl/" }, "Open Data Commons Open Database License"),
                    ' ',
                    "(ODbL) by Colouring ",
                    config.cityName,
                    " contributors."),
                React.createElement("p", null,
                    "You are free to copy, distribute, transmit and adapt our data, as long as you credit Colouring ",
                    config.cityName,
                    " and our contributors. If you alter or build upon our data, you may distribute the result only under the same license."),
                React.createElement("p", null,
                    "Choose one of the links below to download an archive containing the open data collected on the Colouring ",
                    config.cityName,
                    " platform."),
                React.createElement("p", null,
                    "By downloading data extracts from this site, you agree to the",
                    ' ',
                    React.createElement(Link, { to: "/data-accuracy.html" }, "data accuracy agreement"),
                    "."),
                this.state.extracts == undefined ?
                    React.createElement("p", null, "Loading extracts...") :
                    (this.state.extracts.length === 0 ?
                        React.createElement("p", null, "No extracts available.") :
                        null),
                this.state.latestExtract != undefined ?
                    React.createElement("div", null,
                        React.createElement("h1", { className: "h3" }, "Latest extract"),
                        React.createElement(ExtractDownloadLink, Object.assign({}, this.state.latestExtract))) :
                    null,
                this.state.previousExtracts && this.state.previousExtracts.length > 0 ?
                    (React.createElement("div", null,
                        React.createElement("h1", { className: "h3" }, "Older extracts"),
                        React.createElement("ul", null, this.state.previousExtracts.map(e => React.createElement("li", null,
                            React.createElement(ExtractDownloadLink, Object.assign({}, e))))))) :
                    null)));
    }
}
const ExtractDownloadLink = (props) => (React.createElement("p", null,
    React.createElement("a", { href: props.download_path },
        "Extracted on ",
        props.extracted_on.toDateString())));
